import { useTranslation } from 'react-i18next';
import { TrendingDown, Clock, Zap, Smile } from 'lucide-react';

const metricIcons = {
  costReduction: TrendingDown,
  hoursSaved: Clock,
  responseTimeImprovement: Zap,
  satisfaction: Smile,
};

const metricLabels = {
  costReduction: "Cost Reduction",
  hoursSaved: "Hours Saved",
  responseTimeImprovement: "Response Improvement",
  satisfaction: "Satisfaction",
};

export default function CaseStudyHero({ company, industry, headline, results }) {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden border-b border-zinc-900 bg-black">
      <div className="absolute inset-0 grid-bg opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#09090B]" />

      {/* Decorative glow */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 pt-20 pb-12">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-6">
          // CASE STUDY
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="inline-flex items-center gap-2 border border-amber-500/30 px-3 py-1 mb-4">
              <div className="w-1.5 h-1.5 bg-amber-500 rounded-full animate-pulse" />
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-amber-500">
                {industry}
              </span>
            </div>

            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95] text-white mb-6">
              {company}
            </h1>
            <p className="text-2xl sm:text-3xl font-display text-amber-500 uppercase leading-tight">
              {headline}
            </p>
          </div>

          {/* Metrics summary cards */}
          {results && results.length > 0 && (
            <div className="grid grid-cols-2 gap-3">
              {results.map((r, i) => (
                <div
                  key={i}
                  className="relative border border-zinc-800 bg-zinc-950/60 p-5 group hover:border-amber-500/30 transition-all duration-300"
                >
                  <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-amber-500/0 via-amber-500/50 to-amber-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <div className="font-display text-3xl md:text-4xl text-amber-500 mb-1">
                    {r.value}
                  </div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400">
                    {r.label}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
